export const dateMonthsBefore = (date: Date, months: number) => {
  const currentMonth = date.getMonth()
  date.setMonth(currentMonth - months)
  if (currentMonth - months < 0 && date.getMonth() !== currentMonth + months) {
    date.setDate(0)
  } else if (
    currentMonth - months >= 0 &&
    date.getMonth() !== currentMonth - months
  ) {
    date.setDate(0)
  }
  return date
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Date.ts